import LogoLoader from "@client/app/components/LogoLoader";
import { useState } from "react";
type ImageLoaderProps = React.ImgHTMLAttributes<HTMLImageElement>;
type LoadingProps = React.HTMLAttributes<HTMLDivElement>;

function Placeholder(props: LoadingProps) {
	return (
		<div {...props}>
			<div className="flex h-full w-full items-center justify-center rounded-full border border-white/15 text-white/40">
				<LogoLoader className="w-1/2" aria-hidden />
			</div>
		</div>
	);
}

function ImageLoader(props: ImageLoaderProps) {
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const onLoadComplete = () => {
		setIsLoading(false);
	};

	return (
		<>
			{isLoading && <Placeholder {...props} />}
			<img
				onLoad={(e) => {
					props.onLoad?.(e);
					onLoadComplete();
				}}
				onError={(e) => {
					props.onError?.(e);
					onLoadComplete();
				}}
				style={{ display: isLoading ? "none" : "block" }}
				{...props}
				className={`rounded-full ${props.className}`}
			/>
		</>
	);
}

export default ImageLoader;
